export const GROUP_MEMBER_SUBSCRIPTION_LABELS = {
  NONE: 'Sin suscripción',
  EXPIRED: 'Vencida',
  EXPIRING: 'Próximo a expirar',
  ACTIVE: 'Vigente',
  UNAVAILABLE: 'No disponible',
  LOADING: 'Consultando…',
  PLAN_FALLBACK: 'Plan',
} as const;
